import { useTranslation } from "react-i18next";

/**
 * OfflinePage — served by the service worker's navigation fallback when the
 * network is unavailable and the requested document isn't in the cache.
 * Workbox points `navigateFallback` at `/offline` (see vite.config.ts).
 */
export default function OfflinePage() {
  const { t } = useTranslation();
  return (
    <section className="max-w-prose">
      <h1 className="font-display text-3xl font-bold mb-md">{t("pwa.offlineTitle")}</h1>
      <p className="text-neutral-700">{t("pwa.offlineBody")}</p>
    </section>
  );
}
